<div
  class="chips-tags chips-tags--large"
  [ngClass]="componentClasses()"
  [attr.role]="isChip() ? 'button' : 'status'"
  [attr.aria-disabled]="isChip() && disabled() ? true : null"
  [attr.tabindex]="isChip() && !disabled() ? 0 : null"
  (click)="onClick()"
  (keydown.enter)="onClick()"
  (keydown.space)="onClick()"
>
  @if (shouldShowIcon()) {
    <span class="chips-tags__icon" [attr.aria-hidden]="true">
      @switch (tagState()) {
        @case ('rejected') {
          <v-one-icon [name]="'rejected'" [type]="iconType.FILLED" />
        }
        @case ('warning') {
          <v-one-icon [name]="'underReview'" [type]="iconType.FILLED" />
        }
        @case ('approved') {
          <v-one-icon [name]="'approved'" [type]="iconType.FILLED" />
        }
        @case ('informative') {
          <v-one-icon [name]="'current'" [type]="iconType.FILLED" />
        }
      }
    </span>
  }

  <!-- Label Text -->
  <span class="chips-tags__text">{{ label() | translate }}</span>

  <!-- Close Button (only for closeable chips) -->
  @if (isChip() && closeable()) {
    <button
      type="button"
      class="chips-tags__close"
      (click)="onClose($event)"
      [disabled]="disabled()"
      [attr.aria-label]="'chipsAndTags.close' | translate"
    >
      <v-one-icon [name]="'close'" [type]="iconType.OUTLINE" />
    </button>
  }
</div>
